// ═══════════════════════════════════════════════════════════════════
// Selectify UI Configuration
// ═══════════════════════════════════════════════════════════════════

export const CONFIG = {
  // Logo
  LOGO_URL: '/isg-labs-logo.png',

  // Interview configuration
  TOTAL_QUESTIONS: 20,
  TOTAL_INTERVIEW_SECS: 90 * 60, // 90 minutes in seconds

  // Timer durations (in seconds) based on question complexity
  TIMER_DURATIONS: {
    basic: 120,
    medium: 300,
    complex: 600,
  },
  PROGRAMMING_MULTIPLIER: 2, // Programming questions get 2x duration

  // API configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://pariksha.isglabs.ai',

  // Interview code prefix
  CODE_PREFIX: 'SEL', // Changed from 'ISG' for Selectify

  // Tracks
  TRACKS: [
    { id: 1, name: 'Java, SQL, NoSQL & Microservices', icon: '☕', topics: ['Java OOP', 'REST Microservices', 'SQL', 'NoSQL', 'Aptitude', 'Programming'] },
    { id: 2, name: 'Python, LangChain, LangGraph & NoSQL', icon: '🐍', topics: ['Python', 'LangChain', 'LangGraph', 'NoSQL', 'Aptitude', 'Programming'] },
    { id: 3, name: 'Agentic AI, LLM & AI Product Build', icon: '🤖', topics: ['Agentic Workflows', 'LLM', 'RAG Pipelines', 'AI Product Architecture', 'Aptitude', 'Programming'] },
    { id: 4, name: 'Angular, HTML, JavaScript & CSS', icon: '🅰️', topics: ['Angular', 'HTML5', 'JavaScript', 'CSS', 'Aptitude', 'Programming'] },
  ],

  // Experience levels
  EXPERIENCE_LEVELS: [
    { id: 'fresher', label: 'Fresher', complexity: 'basic', color: '#6ee7b7' },
    { id: '1-3', label: '1–3 Years', complexity: 'medium', color: '#93c5fd' },
    { id: '4-6', label: '4–6 Years', complexity: 'medium', color: '#c4b5fd' },
    { id: '7-10', label: '7–10 Years', complexity: 'complex', color: '#fca5a5' },
  ],
};
